import React from 'react';
import { useNavigate } from 'react-router-dom';

import { withAnalyticsSearch } from '@candu-ai/analytics/search';
import { withDocumentNodeId } from '@candu-ai/analytics/utils';
import { EntitlementName, useEntitlementAccess } from '@candu-ai/organizations/entitlements';
import { useAuthentication } from 'commons/hooks';
import { Section } from 'craft/containers/Toolbox/components';
import { useCraftPropsContext } from 'craft/contexts';
import { useMultiNodes } from 'craft/hooks';
import { ANALYTICS_ROUTE } from 'dashboard/pages/Content/pages/Analytics';

import { AllowedNodeAnalyticsComponents, NodeAnalytics } from './NodeAnalytics';

interface Props {
  nodeId: string;
}

const InteractionAnalyticsImpl = ({ nodeId }: Props) => {
  const { type } = useMultiNodes([nodeId], (node) => ({ props: node?.data?.props }));
  const { documentId, contentMetadata } = useCraftPropsContext();
  const { hasEntitlementAccess } = useEntitlementAccess(EntitlementName.AnalyticsComponents);
  const { applicationSlug } = useAuthentication();
  const navigate = useNavigate();

  if (!type || !AllowedNodeAnalyticsComponents.includes(type)) {
    return null;
  }

  if (!contentMetadata) {
    return null;
  }

  if (!hasEntitlementAccess) {
    return <div id="entitlements-splash-toolbox-component-analytics" />;
  }

  const documentNodeId = withDocumentNodeId(documentId, nodeId);

  return (
    <Section
      id="toolbox-interactionanalytics"
      key={`toolbox-interactionanalytics-${documentNodeId}`}
      name="Analytics"
      nameSuffix="last 7 days"
      onClick={() =>
        navigate(
          `/workspaces/${applicationSlug}/editor/${contentMetadata.id}/${
            ANALYTICS_ROUTE.path
          }?gvm=c${documentNodeId ? `&dn_id=${documentNodeId}` : ''}`,
        )
      }
    >
      <NodeAnalytics
        nodeType={type}
        contentId={contentMetadata.id}
        documentNodeId={documentNodeId}
      />
    </Section>
  );
};

export const InteractionAnalytics = withAnalyticsSearch(InteractionAnalyticsImpl);
